import { define, ui } from '@owenscorning/pcb.alpha';

import Renderer from '../../../../OC/PageBuilder/QuietZoneCalculator';

export default define`QuietZone Calculator`('0.0.1')({
  thumbnail: ui`Modules/Page/Thumbnails/QuietZoneCalculator`,
  category: ui`Modules/Categories/Page/Prebuilt`,
  // eslint-disable-next-line react/jsx-props-no-spreading
  view: ({ value }) => <Renderer {...value} />,
  edit: {
    footnotes: ui`Text/Rich`({ label: 'Footnotes' }),
  },
});
